import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import { Fragment } from 'react';

import plusIcon from 'assets/images/icons/plus.svg';

import './RequestsTab.scss';

import { Button } from '../../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import useRequestsTabVM from './useRequestsTabVM';
import { Loader } from 'components/Loader/Loader';
import { Person } from 'services/person/person.types';


export default function RequestsTab({ person }: { person: Person }) {
    const navigate = useNavigate();
    const {
        requests,
        isGetUserProjectRequestLoading,
        personId,
        setPersonProjectRequestToEdit
    } = useRequestsTabVM(person);

    if (isGetUserProjectRequestLoading) {
        return <><Loader /></>;
    }

    function renderRequests() {
        if (!requests) return null;

        return requests.map((request, index) => (
            <Fragment key={request.reference}>
                <ContentBlock title={`${index + 1} ~ ` + request.label} isEditable onEditClick={() => setPersonProjectRequestToEdit(request)}>
                    {/* <div className="line"> */}
                    {/*     <p className="subtitle">Référence</p> */}
                    {/*     <Chip color="success" label="Actif" compact />  */}
                    {/*     <p>{request.reference}</p> */}
                    {/* </div> */}
                    {/* <div className="line"> */}
                    {/*     <p className="subtitle">Nombre d'heures suivies</p> */}
                    {/*     <p>18h23</p> */}
                    {/* </div> */}
                    <p className="subtitle">Détail de la demande</p>
                    <div dangerouslySetInnerHTML={{ __html: request.observation }} />
                </ContentBlock>
                {request.user_comment && (
                    <ContentBlock title="Commentaire de la personne soutenue" postIt>
                        <p style={{ whiteSpace: 'pre-wrap' }}>{request.user_comment}</p>
                    </ContentBlock>
                )}
            </Fragment>
        ));
    }

    return (
        <section className="persons-requests">
            <Button
                label="Ajouter une demande"
                variant="light"
                icon={<img src={plusIcon} alt="" />}
                iconBefore
                callback={() => navigate(`/app/admin/persons/${personId}/project/${person?.projects[0].id}/requests/new`)}
            />
            {requests.length ? (
                <div className="requests-container">{renderRequests()}</div>
            ) : (
                <div className="requests-container">Aucune demande n'a été enregistrée</div>
            )}
        </section>
    );
}
